export enum Height {
  screen = 'screen',
  default = 'default',
  fluid = 'fluid'
}

